import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function HistorySection() {
  return;
}